import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

import { EmptyState } from './EmptyState';
import { Button } from './ui/button';
import usePageTitle from '../hooks/usePageTitle';

/**
 * Shown in place when a route's permission check fails — an explanation,
 * not a silent bounce. Deep links stay shareable: once access is granted,
 * the same URL just works.
 */
const AccessDenied: React.FC = () => {
  usePageTitle('Access needed');

  return (
    <EmptyState
      titleAs="h1"
      icon={Lock}
      title="You need access to view this page"
      description="Your role in the current organization doesn’t include this permission. Switch organizations, or ask an organization admin to grant you access."
      action={
        <Button asChild variant="outline">
          <Link to="/my-apps">Go to App Clients</Link>
        </Button>
      }
      className="py-20"
    />
  );
};

export default AccessDenied;
